<template lang="pug">
  div
    .main
      .row
        .col-md-6.col-lg-5.col-xl-4
          h2.title 微信营业厅-数据总览
</template>

<script>
export default {
  name: 'dashboard'
}
</script>

<style lang="sass" scoped>
</style>



// WEBPACK FOOTER //
// Dashboard.vue?6b957f1a